import { createAsyncThunk } from "@reduxjs/toolkit";
import EquityGrantsService from "../../services/equity-grants.service";

export const ListEquityGrants = createAsyncThunk(
  "/post/equity-grants/list",
  async (item, thunkAPI) => {
    try {
      const data = await EquityGrantsService.list(item);
      return data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message });
    }
  }
);

export const AddEquityGrant = createAsyncThunk(
  "/post/equity-grants/add",
  async (item, thunkAPI) => {
    try {
      const data = await EquityGrantsService.add(item);
      return data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message });
    }
  }
);

export const EquityGrantDetail = createAsyncThunk(
  "/post/equity-grants/detail",
  async (item, thunkAPI) => {
    try {
      const data = await EquityGrantsService.detail(item);
      return data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message });
    }
  }
);

export const DeleteEquityGrant = createAsyncThunk(
  "/post/equity-grants/delete",
  async (item, thunkAPI) => {
    try {
      const data = await EquityGrantsService.delete(item);
      return data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message });
    }
  }
);
